<template>
  <v-container 
    fluid
    class="px-6"
  >
    <slot></slot>
  </v-container>
</template>

<script>
export default {
    name: 'HdContainer'
}
</script>
